export const GRAPHQL_URL = `${window.ENV.HTTP_URL}/audit/graphql`
// export const GRAPHQL_URL = 'http://localhost:4000/audit/graphql'
